import { Injectable } from '@angular/core';
import { Observable, delay, map, of } from 'rxjs';

import { DemoCardsScreenFieldModel } from '@demo/data';
import { ScreenFieldModel } from '@models/module/fields/main';
import { GridViewModel } from '@models/module/grid';
import { DataCardsViewService } from '@module-instance/data-card/data-cards-view/data-cards-view.service';

@Injectable()
export class DemoCardsService extends DataCardsViewService {
  getScreenFields(): Observable<GridViewModel<ScreenFieldModel[]>> {
    return of(null).pipe(
      map(() => DemoCardsScreenFieldModel),
      delay(100),
    );
  }
}
